<template>
  <div id="bookingTop" class="booking-request" v-loading="loading">
    <div v-if="canBook">
      <steps-list v-if="step < 5" :steps="steps" v-model="step" />
      <form v-if="step < 4" @submit.prevent="submitForm()">
        <simple-driver
          v-if="step === 1 && page.owner"
          :items.sync="owner"
          :errors.sync="ownerErrors"
          #default="{ driver }"
        >
          <blocks-view :driver="driver" :page="page.owner" />
        </simple-driver>
        <simple-driver
          v-if="step === 2 && page.boat"
          :items.sync="boat"
          :errors.sync="boatErrors"
          #default="{ driver }"
        >
          <blocks-view :driver="driver" :page="page.boat" />
        </simple-driver>
        <simple-driver
          v-if="step === 3 && page.booking"
          :items.sync="booking"
          :errors.sync="bookingErrors"
          #default="{ driver }"
        >
          <blocks-view :driver="driver" :page="page.booking" />
        </simple-driver>
        <div class="booking-request__continue">
          <button type="submit" @click="$scrollTo('body')">
            {{ $t("booking_request.save_and_continue") }}
          </button>
        </div>
      </form>
      <booking-summary
        v-else-if="step === 4"
        :owner="owner"
        :boat="boat"
        :booking="booking"
        @submit="submitForm()"
      />
      <booking-success v-else />
    </div>
    <div v-else>
      <form v-if="!showSummary" @submit.prevent="calculateQuote">
        <rest-store-driver resource="quote" #default="{ driver }">
          <blocks-view :driver="driver" :page="quotePage" />
        </rest-store-driver>
        <div class="booking-request__continue">
          <button type="submit" @click="$scrollTo('body')">
            {{ $t("booking_request.save_and_continue") }}
          </button>
        </div>
      </form>
      <booking-summary
        v-if="showSummary"
        :owner="owner"
        :boat="boat"
        :booking="booking"
        :initial-quote="quote"
        @submit="submitForm()"
      />
    </div>
  </div>
</template>

<script>
import StepsList from './StepsList'
import BookingSummary from './BookingSummary'
import BookingSuccess from './BookingSuccess'

function computedErrors(resource) {
  return {
    get() {
      return this.$store.getters[`${resource}/errors`]
    },
    set(newValue) {
      return this.$store.dispatch(`${resource}/clearError`, newValue)
    }
  }
}

export default {
  components: {
    StepsList,
    BookingSummary,
    BookingSuccess
  },

  data() {
    return {
      owner: {},
      boat: {},
      booking: {},
      loading: false,
      showSummary: false,
      steps: [
        this.$t('booking_request.owner'),
        this.$t('booking_request.boat'),
        this.$t('booking_request.booking'),
        this.$t('booking_request.summary')
      ],
      step: 1,
      okStep: 0
    }
  },

  computed: {
    ownerErrors: computedErrors('owners'),
    boatErrors: computedErrors('boats'),
    bookingErrors: computedErrors('bookings'),
    page() {
      return this.$store.getters['bookings/create']
        ? this.$store.getters['bookings/create'].pages || {}
        : {}
    },
    quotePage() {
      return this.$store.getters['quote/create']
        ? this.$store.getters['quote/create'].main || {}
        : {}
    },
    canBook() {
      return !!this.$store.getters.options.canBook
    },
    quote() {
      return this.$store.getters['quote/quote'] || {}
    }
  },

  async created() {
    this.loading = true
    await this.$store.dispatch('bookings/create')
    await this.$store.dispatch('quote/create')
    this.loading = false
  },

  methods: {
    submitForm: async function() {
      if (this.step < 4) return this.step++
      if (!(await this.submitResource('owners', this.owner, 1)))
        return (this.step = 1)
      if (!(await this.submitResource('boats', this.boat, 2)))
        return (this.step = 2)
      this.booking.owner_id = this.$store.getters['owners/item'].id
      this.booking.boat_id = this.$store.getters['boats/item'].id
      if (
        !(await this.submitResource(
          'bookings',
          { ...this.booking, source: 'website' },
          3
        ))
      )
        return (this.step = 3)
      return (this.step = 5)
    },
    submitResource: async function(resource, item, checkStep) {
      this.loading = true
      if (this.okStep >= checkStep) return true
      await this.$store.dispatch(`${resource}/store`, item)
      this.loading = false
      let success = this.successRequest(resource)
      if (success) this.okStep = checkStep
      return success
    },
    successRequest: function(resource) {
      let errors = this.$store.getters[`${resource}/errors`]
      if (errors) {
        return !Object.keys(errors).length
      }
      return true
    },
    async calculateQuote() {
      await this.$store.dispatch('quote/calculate')
      if (this.$withoutErrors('quote')) {
        const { length, width, from, to } = this.$store.getters['quote/item']
        this.boat.length = length
        this.boat.width = width
        this.booking.from = from
        this.booking.to = to
        this.showSummary = true
      }
    }
  }
}
</script>
